import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

type CopyButtonProps = {
  text: string;
};

const COMMON_STYLES = `
font-size: 12px;
font-weight: bold;
text-transform: none;
color: white;
margin: 5px 0;
padding: 5px 15px;
width: 70px;
display: inline-flex;
justify-content: center;
align-items: center;
border-width: 1px;
border-style: solid;
outline: none;

&:hover {
  background-color: #6564ee;
  border-color: #6564ee;
}
`;

const ActiveButton = styled.button`
  ${COMMON_STYLES}
  background-color: #6564EE;
  border-color: #6564ee;
`;

const InactiveButton = styled.button`
  ${COMMON_STYLES}
  background-color: #5046E5;
  border-color: #5046e5;
`;

const ButtonText = styled.div`
  display: flex;
  align-items: center;
`;
const CopyButton = ({ text }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 1000);
    }
  }, [copied]);

  const handleOnClick = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => setCopied(true))
      .catch(() => null);
  };

  return (
    <>
      {copied ? (
        <ActiveButton onClick={() => handleOnClick()}>
          <ButtonText>Copied!</ButtonText>
        </ActiveButton>
      ) : (
        <InactiveButton onClick={() => handleOnClick()}>
          <ButtonText>Copy</ButtonText>
        </InactiveButton>
      )}
    </>
  );
};

export default CopyButton;
